import getRoutePoint from './getRoutePoint';

export const defaultRoutePoints = [getRoutePoint(), getRoutePoint()];
